import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';
import { PartnerNote, PartnerNotesDataStore } from './partner-notes.store';
import { DirtyChecker2 } from '../../loan-state/core/dirty-checker-2';

@Injectable({ providedIn: 'root' })
export class PartnerNotesQuery extends Query<PartnerNote> {
  protected store: PartnerNotesDataStore;

  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);
  constructor() {
    const store = inject(PartnerNotesDataStore);

    super(store);
    this.store = store;

    this.dirtyChecker2.dirtyChecker.setHead();
  }
}
